import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Stack } from '@lyearn/ui';
import { GroupTypeEnum } from '@/types/schema';

import { ConditionalFieldsMapping, FilterInputsD2 } from '../../types';
import FilterItem, { FilterItemOverrides, FilterItemProps } from '../FilterItem';

export interface FiltersProps {
  filters: Array<FilterInputsD2 & { tempId: string }>;
  onChange: (item: FilterInputsD2, index: number) => void;
  onRemoveFilter: (index: number) => void;
  error?: boolean;
  type: GroupTypeEnum;
  filterItemOverrides?: FilterItemOverrides;
  RenderFilterItem?: (params: FilterItemProps) => React.JSX.Element;
  disabled?: boolean;
  className?: string;
  fieldsMapping?: ConditionalFieldsMapping[];
  showPlaceholderIcon?: boolean;
  order?: number;
}

function Filters(props: FiltersProps) {
  const { filters, filterItemOverrides, RenderFilterItem, ...rest } = props;
  const { t } = useTranslation();
  return (
    <Stack alignItems="start" className="mt-20 w-full" direction="col">
      {filters.map((filter, index) =>
        RenderFilterItem ? (
          <RenderFilterItem key={filter.tempId} filter={filter} index={index} {...rest} />
        ) : (
          <FilterItem
            key={filter.tempId}
            filter={filter}
            index={index}
            overrides={filterItemOverrides}
            {...rest}
          />
        ),
      )}
    </Stack>
  );
}

export default Filters;
